// third-party
import { FormattedMessage } from 'react-intl';

// assets
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import AssignmentIndOutlinedIcon from '@mui/icons-material/AssignmentIndOutlined';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';

const icons = {
  HealthAndSafetyOutlinedIcon,
  BusinessOutlinedIcon,
  AssignmentIndOutlinedIcon,
  PriceChangeOutlinedIcon,
};

// ==============================|| MENU ITEMS - INSURANCE MANAGEMENT ||============================== //

const insurance = {
  id: 'insurance',
  title: <FormattedMessage id="Insurance Management" />,
  icon: icons.HealthAndSafetyOutlinedIcon,
  type: 'group',
  children: [
    {
      id: 'insurance_providers',
      key: 'insurance_providers',
      title: <FormattedMessage id="Insurance Providers" />,
      type: 'item',
      url: '/insurance/providers',
      icon: icons.BusinessOutlinedIcon,
    },
    {
      id: 'insurance_registration',
      key: 'insurance_registration',
      title: <FormattedMessage id="Insurance Registration" />,
      type: 'item',
      url: '/insurance/registration',
      icon: icons.AssignmentIndOutlinedIcon,
    },
    {
      id: 'insurance_pricing',
      key: 'insurance_pricing',
      title: <FormattedMessage id="Insurance Pricing" />,
      type: 'item',
      url: '/insurance/pricing',
      icon: icons.PriceChangeOutlinedIcon,
    },
  ],
};

export default insurance;
